import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { setThemeColors, setGradientColors } from "../../redux/actions";
import CloseKycScreen from "./components/CloseKycScreen";
import useIdle from "hooks/useIdleTimeout";

// themes
// 101
import LeftBarDesign101 from "../../design1/LeftBarDesign";
// 102
import LeftBarDesign102 from "../../design2/LeftBarDesign";
// 103
import LeftBarDesign103 from "../../design3/LeftBarDesign";
// 104
import LeftBarDesign104 from "../../design4/LeftBarDesign";
// 105
import LeftBarDesign105 from "../../design5/LeftBarDesign";
// 106
import LeftBarDesign106 from "../../design6/LeftBarDesign";
// 107
import LeftBarDesign107 from "../../design7/LeftBarDesign";
// 108
import LeftBarDesign108 from "../../design8/LeftBarDesign";
// 109
import LeftBarDesign109 from "../../design9/LeftBarDesign";
// 110
import LeftBarDesign110 from "../../design10/LeftBarDesign";

function LeftBarDesign({ theme, ...props }) {
  switch (theme) {
    case "101":
      return <LeftBarDesign101 {...props} />;
    case "102":
      return <LeftBarDesign102 {...props} />;
    case "103":
      return <LeftBarDesign103 {...props} />;
    case "104":
      return <LeftBarDesign104 {...props} />;
    case "105":
      return <LeftBarDesign105 {...props} />;
    case "106":
      return <LeftBarDesign106 {...props} />;
    case "107":
      return <LeftBarDesign107 {...props} />;
    case "108":
      return <LeftBarDesign108 {...props} />;
    case "109":
      return <LeftBarDesign109 {...props} />;
    case "110":
      return <LeftBarDesign110 {...props} />;
    default:
      return <LeftBarDesign101 {...props} />;
  }
}

const CloseKyc = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { brokerID } = useParams();
  const { themeTemplate } = useSelector((state) => state.theme);
  const [requestType, setRequestType] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleIdle = () => {
    window.location.href = `/c/${brokerID}`;
    localStorage.clear();
    sessionStorage.clear();
  };

  const { idleTimer } = useIdle({ onIdle: handleIdle, idleTime: 900 }); // 15min

  const handleStay = () => {
    setOpenModal(false);
    idleTimer.reset();
  };

  useEffect(() => {
    const theme = window.sessionStorage.getItem("theme_color_pallate");
    const gradient = window.sessionStorage.getItem("gradientColor");
    if (theme && gradient) {
      dispatch(setThemeColors(JSON.parse(theme)));
      dispatch(setGradientColors(JSON.parse(gradient)));
    }
  }, [dispatch]);

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (!user) {
      return history.push(`/c/${brokerID}`);
    }
  }, [history, brokerID]);

  return (
    <>
      <LeftBarDesign
        theme={themeTemplate}
        innerDesign={
          <CloseKycScreen
            requestType={requestType}
            setRequestType={setRequestType}
          />
        }
      />
      <Modal
        show={openModal}
        onHide={handleStay}
      >
        <Modal.Header>
          <Modal.Title>Your session is expire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Your session is expire. You'll be automatically signed out.</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CloseKyc;
